<orbit-fa-icon [iconName]="icon()" />
<div class="content">
  @let titleValue = title();
  @if (titleValue) {
    <p class="title" [attr.data-testid]="titleTestId()">{{ titleValue }}</p>
  }
  @let link = messageAddonLink();
  <p [attr.data-testid]="messageTestId()">
    {{ message() }}
    &nbsp;
    @if (link) {
      <br />
      <a [attr.href]="link.url" target="_blank">{{ link.text }}</a>
    }
  </p>
  @if (list()) {
    @let key = listKey();
    <ul>
      @for (item of list(); track $index) {
        <li>{{ item[key] }}</li>
      }
    </ul>
  }
</div>
@let addonIconValue = addonButtonIcon();
@if (addonIconValue) {
  <div class="addon-icon">
    <orbit-button
      rounded
      [icon]="addonIconValue"
      severity="primary"
      (buttonClick)="addonButtonClick.emit()"
      (keydown)="onAddonButtonKeyDown($event)" />
  </div>
}
